/*
 * Kompatibilitas Bootstrap 3 -> Bootstrap 5 (AzZahra CBT, aplikasi lama).
 *  - Atribut data-toggle/data-target/data-dismiss/... (BS3) dipetakan ke data-bs-* (BS5) tepat sebelum
 *    handler klik BS5 berjalan, sehingga template lama & yang dirender AngularJS tetap berfungsi.
 *  - Kelas "in" (BS3) pada .collapse diubah ke "show" agar dapat dibuka/tutup oleh BS5.
 *  - Inisialisasi tooltip/popover BS3 ($('[data-toggle=tooltip]').tooltip()) tetap memakai plugin jQuery BS5.
 */
(function () {
    var ATTR = ['toggle', 'target', 'dismiss', 'parent', 'placement', 'container', 'trigger', 'html', 'content',
        'backdrop', 'keyboard', 'offset', 'delay', 'animation', 'original-title', 'title', 'spy', 'ride', 'slide', 'slide-to', 'interval'];

    function petakan(el) {
        if (!el || el.nodeType !== 1 || el.__bs3ok) return;
        // Tab/pill BS3 (li.active) ditangani tabBs3(); jangan serahkan ke Tab BS5 (mencari .active di <a>).
        var tg = el.getAttribute('data-toggle');
        if (tg === 'tab' || tg === 'pill') { el.__bs3ok = true; return; }
        for (var i = 0; i < ATTR.length; i++) {
            var a = 'data-' + ATTR[i];
            if (el.hasAttribute(a) && !el.hasAttribute('data-bs-' + ATTR[i])) {
                var v = el.getAttribute(a);
                // BS3: data-toggle="dropdown" pada tombol, data-target sering kosong/"#"
                el.setAttribute('data-bs-' + ATTR[i], v);
            }
        }
        // <a href="#id" data-toggle="collapse/modal/tab"> : BS5 juga membaca href, tidak perlu diubah.
        el.__bs3ok = true;
    }

    // Handler delegasi BS5 terpasang di document pada fase CAPTURE; listener di window (capture)
    // selalu berjalan lebih dulu, sehingga atribut data-bs-* sudah ada saat BS5 memeriksanya.
    window.addEventListener('click', function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var el = t.closest('[data-toggle],[data-dismiss]');
        if (!el) return;
        var tg = el.getAttribute('data-toggle');
        if (tg === 'tab' || tg === 'pill') { tabBs3(el, e); return; }
        petakan(el);
    }, true);

    /** Tab BS3: <ul class="nav nav-tabs"><li class="active"><a data-toggle="tab" href|data-target="#id"> */
    function tabBs3(a, e) {
        var sel = a.getAttribute('data-target') || a.getAttribute('href');
        if (e && (a.getAttribute('href') || '').charAt(0) === '#') e.preventDefault();
        if (!sel || sel === '#' || sel.charAt(0) !== '#') return;
        var pane = document.querySelector(sel);
        var li = a.closest('li');
        if (!pane || (li && li.classList.contains('active'))) return;
        var $ = window.jQuery, prev = null;
        var ul = a.closest('ul, .nav');
        if (ul) {
            var aktif = ul.querySelector(':scope > li.active > a, :scope > .active');
            prev = aktif;
            ul.querySelectorAll(':scope > li.active, :scope > .active').forEach(function (x) { x.classList.remove('active'); });
            ul.querySelectorAll('[data-toggle="tab"].active, [data-toggle="pill"].active').forEach(function (x) { x.classList.remove('active'); });
        }
        if ($) $(a).trigger($.Event('show.bs.tab', { relatedTarget: prev }));
        if (li) li.classList.add('active'); else a.classList.add('active');
        var wadah = pane.parentNode;
        if (wadah) {
            [].forEach.call(wadah.children, function (x) {
                if (x !== pane && x.classList.contains('tab-pane')) x.classList.remove('active', 'in', 'show');
            });
        }
        pane.classList.add('active', 'in', 'show');
        if ($) $(a).trigger($.Event('shown.bs.tab', { relatedTarget: prev }));
    }
    ['mouseover', 'focusin'].forEach(function (ev) {
        window.addEventListener(ev, function (e) {
            var t = e.target;
            if (t && t.closest) {
                var el = t.closest('[data-toggle="tooltip"],[data-toggle="popover"]');
                if (el) petakan(el);
            }
        }, true);
    });

    function rapikan(root) {
        if (!root || !root.querySelectorAll) return;
        var list = root.querySelectorAll('.collapse.in, .panel-collapse.in');
        for (var i = 0; i < list.length; i++) {
            list[i].classList.add('show');
            list[i].classList.remove('in');
        }
        var t = root.querySelectorAll('[data-toggle],[data-dismiss]');
        for (var j = 0; j < t.length; j++) petakan(t[j]);
    }

    function mulai() {
        rapikan(document);
        if (window.MutationObserver) {
            new MutationObserver(function (muts) {
                for (var i = 0; i < muts.length; i++) {
                    var m = muts[i];
                    for (var k = 0; k < m.addedNodes.length; k++) {
                        var n = m.addedNodes[k];
                        if (n.nodeType === 1) {
                            if (n.classList && n.classList.contains('collapse') && n.classList.contains('in')) { n.classList.add('show'); n.classList.remove('in'); }
                            rapikan(n);
                        }
                    }
                }
            }).observe(document.documentElement, { childList: true, subtree: true });
        }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mulai); else mulai();

    // Plugin jQuery BS5 ($.fn.modal/tooltip/popover/...) didaftarkan BS5 baru saat DOMContentLoaded;
    // kode lama memanggilnya lebih awal. Daftarkan segera + petakan metode BS3 'destroy' -> 'dispose'.
    function daftarJquery() {
        var $ = window.jQuery, bs = window.bootstrap;
        if (!$ || !bs) return;
        ['Alert', 'Button', 'Carousel', 'Collapse', 'Dropdown', 'Modal', 'Offcanvas', 'Popover', 'ScrollSpy', 'Tab', 'Toast', 'Tooltip'].forEach(function (n) {
            var C = bs[n];
            if (!C || !C.jQueryInterface) return;
            var nama = C.NAME, asli = C.jQueryInterface;
            var fn = function (cfg) {
                if (cfg === 'destroy') cfg = 'dispose';
                return asli.apply(this, arguments.length ? [cfg].concat([].slice.call(arguments, 1)) : arguments);
            };
            fn.Constructor = C;
            fn.__bs3compat = true;
            if (!$.fn[nama] || !$.fn[nama].__bs3compat) $.fn[nama] = fn;
        });
    }
    daftarJquery();

    // Collapse BS5 menandai elemen dengan .show; CSS lama (Metronic) memakai .in -> sinkronkan keduanya.
    document.addEventListener('show.bs.collapse', function (e) { if (e.target && e.target.classList) e.target.classList.add('in'); });
    document.addEventListener('hide.bs.collapse', function (e) { if (e.target && e.target.classList) e.target.classList.remove('in'); });
    // BS5 menimpa $.fn.* saat DOMContentLoaded; pasang ulang pembungkus setelahnya.
    document.addEventListener('DOMContentLoaded', function () { setTimeout(daftarJquery, 0); });
})();
